<section class="toggle-form curriculum-training-item-group-management-slider"
    [ngClass]="{ active: isCurriculumTrainingItemGroupManagementSliderOpen }">
    <div class="formwrap">
        <div class="header">
            <h2>
                <b>{{ curriculumTrainingItemGroupManagementHeaderText }}</b>
            </h2>
            <p-button appPreventDoubleClick styleClass="p-button-text" id="curriculumTrainingItemGroupManagementCloseBtn"
                type="button" label="Close" (debounceClick)="openConfirmationModal()"></p-button>
        </div>
        <div class="mt-3">
            <div class="curriculum-training-item-group-management-container">
                <div class="fields-row" *ngIf="isTrainingItemGroupDropdownVisible">
                    <div class="field">
                        <bpt-dropdown label="Training Item Group(s)" [options]="trainingItemGroups" id="status"
                            [multiSelect]="true" [editable]="false" [showClear]="true" [showFilter]="true"
                            [valueField]="valueField" [labelField]="labelField"
                            [(ngModel)]="selectedTrainingItemGroups"
                            (dropdownChange)="setTrainingItemGroups()">
                        </bpt-dropdown>
                    </div>
                </div>

                <div class="fields-row" *ngIf="isCurriculumDropdownVisible">
                    <div class="field">
                        <bpt-dropdown label="Curriculum(s)" [options]="curriculums" id="status"
                            [multiSelect]="true" [editable]="false" [showClear]="true" [showFilter]="true"
                            [valueField]="valueField" [labelField]="labelField"
                            [(ngModel)]="selectedCurriculums"
                            (dropdownChange)="setCurriculums()">
                        </bpt-dropdown>
                    </div>
                </div>
                <div class="fields-row" *ngIf="isCurriculumDropdownVisible">
                <div class="field scheduled-curriculum-field">
                    <bpt-dropdown
                        label="Scheduled Curriculum(s)"
                        [options]="scheduledCurriculums" 
                        [multiSelect]="true"
                        [editable]="false"
                        [showClear]="true"
                        [showFilter]="true"
                        [valueField]="valueField"
                        [labelField]="labelField"
                        [(ngModel)]="selectedScheduledCurriculums"
                        (dropdownChange)="onScheduledCurriculumsChange()"
                        pTooltip="{{sharedConstants.ScheduledTrainingItemsTooltipMessage}}"
                        tooltipPosition="left">
                    </bpt-dropdown>
                </div>
                </div>
                <div class="fields-row" *ngIf="isTrainingItemGroupDropdownVisible">
                    <div class="field">
                        <bpt-dropdown label="Scheduled Training Item Group(s)" [options]="scheduledTrainingItemGroups" id="status"
                            [multiSelect]="true" [editable]="false" [showClear]="true" [showFilter]="true"
                            [valueField]="valueField" [labelField]="labelField"
                            [(ngModel)]="selectedScheduledTrainingItemGroupsCode"
                            (dropdownChange)="onScheduledTrainingItemGroupChange()"
                            pTooltip="{{sharedConstants.ScheduledTrainingItemsTooltipMessage}}"
                            tooltipPosition="left">
                        </bpt-dropdown>
                    </div>
                </div>
                <div>
                    <p-button appPreventDoubleClick label="Save" type="submit"
                        id="curriculumtrainingItemGroupManagementSaveButton" class="align-right" styleClass="bpt-button-compact"
                        (debounceClick)="saveCurriculumTrainingItemGroupManagement()"
                        [disabled]="!isSaveEnabled">
                    </p-button>
                </div>
            </div>
        </div>
    </div>
</section>